import {
  USER,
  UNIT,
  TITLE,
  STATUS,
  CHANNEL,
  VISIBILITY,
  KEYWORD,
  COLLECTION,
  PERSONALITY,
} from './fields';

export const defaultFilters = [
  TITLE,
  STATUS,
  VISIBILITY,
  USER,
  UNIT,
  CHANNEL,
  PERSONALITY,
  COLLECTION,
  KEYWORD,
];

export const defaultCollectionFilters = [
  TITLE,
  STATUS,
  VISIBILITY,
  USER,
  UNIT,
  CHANNEL,
  PERSONALITY,
  KEYWORD,
];
